<template>
  <div class="add-filter">
    <div class="filter-selection" v-show="isVisible">
      <b-select size="is-small" placeholder="Select a property" v-model="newFilter.property" @input="valuesForFilterProperty">
        <option v-for="(fld, idx) in fields" :key="idx" :value="fld.meta.field">{{fld.value}}</option>
      </b-select>
      <b-input disabled size="is-small" value="equals" style="width: 50px"></b-input>
      <div>
        <b-select size="is-small" placeholder="Select a value" v-model="newFilter.value">
          <option v-for="(fld, idx) in filterValues" :key="idx" :value="fld.id">{{fld.name}}</option>
        </b-select>
      </div>
      <b-button size="is-small" outlined @click="addNewFilter"><font-awesome-icon :icon="['far', 'plus']" /></b-button>
    </div>
    <b-button size="is-small" outlined icon-left="filter" style="margin-left: 0.5rem;" @click="toggleFilterAdd" title="Add filter">
      {{ isVisible ? 'Cancel' : 'Add Filter' }}
    </b-button>
  </div>
</template>
<script>
import { orderBy } from 'lodash';

export default {
  data() {
    return {
      newFilter: {
        property: null,
        comparator: 'eq',
        value: null
      },
      isVisible: false,
      filterValues: []
    }
  },
  methods: {
    addNewFilter() {
      this.addFunction(this.newFilter);
      this.resetFilter();
      this.isVisible = false;
    },
    toggleFilterAdd() {
      if (this.isVisible) {
        this.resetFilter();
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    },
    resetFilter() {
      this.newFilter = { property: null, comparator: 'eq', value: null };
      this.filterValues = [];
    },
    valuesForFilterProperty(value) {
      const filter = this.fields.find(f => f.meta.field == value);
      if (filter && filter.meta && filter.meta.selectable) {
        this.filterValues = orderBy(filter.meta.selectable, ['name'], ['asc']); 
      }
    }
  },   
  props: {
    addFunction: {
      type: Function,
      // eslint-disable-next-line no-unused-vars
      default: (newFilter) => {
        // console.log(newFilter);
      }
    },
    // fields should be objects where for select you'd have
    // { name: '', type: '', values: [{ value: '', label: '' }] }
    // and for input-text you'd have
    // { name: '', type: '' }
    fields: {
      type: Array,
      default: () => []
    }
  }    
}
</script>
<style lang="scss" scoped>
.add-filter {
  display: flex;

  .filter-selection {
    margin-left: 0.5rem;
    display: flex;
  }
}
</style>
